export default __webpack_public_path__ + "static/media/primaryLogo.dca3e0c1.svg";